import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useWoody } from '../../woody/woody.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { shareTokensQueryKeys } from '../queries/shareTokensQueryKeys.js';
import { toast } from '../../store/alerts.js';
import plur from 'plur';

const useMutationShareTokenCreate = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const { track } = useAnalytics();
  return useMutation({
    mutationFn: async (variables) => {
      if (!variables.emails) {
        return Promise.allSettled([
          client.v2({
            endpoint: "/v2/resources/{resourceId}/share-token",
            params: {
              resourceId: variables.resourceId
            }
          }, {
            method: "post",
            body: {
              role: variables.role,
              currentLink: true
            }
          })
        ]);
      }
      return Promise.allSettled(variables.emails.map((email) => {
        return client.v2({
          endpoint: "/v2/resources/{resourceId}/share-token",
          params: {
            resourceId: variables.resourceId
          }
        }, {
          method: "post",
          body: {
            email,
            role: variables.role
          }
        });
      }));
    },
    onSuccess: (_, variables) => {
      if (!variables.emails || variables.emails.length < 1) {
        track(AnalyticsEvents.SharingEnabledPublicLink, {
          resourceId: variables.resourceId,
          role: variables.role
        });
      } else {
        variables.emails.forEach((email) => {
          track(AnalyticsEvents.SharingEmailInvitationCreate, {
            resourceId: variables.resourceId,
            email,
            role: variables.role
          });
        });
        toast({
          id: "share-via-email",
          replace: true,
          content: `Email ${plur("invite", variables.emails.length)} sent`
        });
      }
      if (variables) {
        queryClient.invalidateQueries({
          queryKey: shareTokensQueryKeys.shareTokensPerResourceId(variables.resourceId)
        });
      }
    }
  });
};

export { useMutationShareTokenCreate };
//# sourceMappingURL=useMutationShareTokenCreate.js.map
